module.exports = __webpack_public_path__ + "static/og-2084cec62dca67200911f5f975a5d673.png";